export const EngLocalizedStrings = {
  GlobalLabels: {
    Store: "Store",
    Staff: "Staff",
    Welcome: "Login to CMS PQ",
    Balance: "Balance",
    Carrier: "Internet Service Provider",
    Topup: "Add balance",
    Close: "Close",
    All: "All",
    STT: "No.",
    NoSort: "None",
    Status: "Status",
    Phone: "Phone Number",
    Noti: "Notification",
    Actions: "Actions",
    Active: "Active",
    Position: "Position",
    Inactive: "Inactive",
    Deleted: "Delete",
    Search: "Search",
    Redo: "Refresh Filter",
    Cancel: "Cancel",
    Error: "Error",
    TakePicture: "Take picture",
    Confirmed: "Confirm",
    Detail: "Details",
    Create: "Add new",
    Password: "Password",
    PasswordConfirmed: "Confirm password",
    Description: "Description",
    Update: "Update",
    Address: "Address",
    Partner: "Partner",
    Total: "Total",
    NoPartner: "Not a partner",
    createdAt: "Created date",
    updatedAt: "Updated date",
    Cover: "Background image",
    Success: "Success",
    Failed: "Failed",
    Date: "Date",
    Hour: "Hour",
    ExcelExporting: "Export Excel",
    Type: "Type",
    Name: "Name",
    Regions: "Region",
    Login: "Login",
    NoInfo: "No information",
    ASC: "Ascending",
    DESC: "Descending",
    Logout: "Logout",
    Attention: "See notes here",
    ReloadImages: "Refresh image",
    DownloadImage: "Download image",
    Placeholder: "Import",
    Choose: "Select",
    Images: "Image",
    UserName: "Username",
    Email: "Email",
    Order: "STT",
    Loading: "Loading...",
    Time: "Time",
    Yes: "Yes",
    No: "No",
    Download: "Download",
    User: "User",
    Config: "Configuration",
    Save: "Save",
    Edit: "Edit",
    Supplier: "Supplier",
    SupplierType: "NCC Type",
    Import: "Import",
    ChangeStatus: "Change status",
    AccountManagement: "Account management",
  },
  GlobalMessage: {
    Email: "Enter the correct Email format!",
    UpdateSuccessfully: "Updated successfully!",
    UpdateFailed: "Updated failed:",
    CreateSuccessfully: "Created successfully!",
    CreateFailed: "Created failed:",
    DeleteSuccessfully: "Delete successfully!",
    DeleteFailed: "Delete failed:",
    DeleteConfirmation: "Confirm deleting this element?",
    ResetPassSuccessfully: "Reset password successfully!",
    ResetPassFailed: "Reset password failed:",
    Error: "An error occurred",
    Exporting: "Exporting Report...",
    SystemError:
      "Error retrieving login information or expired token, returning to login page...",
    LoginSuccessfully: "Login successfully!",
    InvalidAccount: "Invalid username or password or User does not exist!",
    InvalidMenuConfig: "Error in getting Sidebar Menu, please try again later!",
    Supplier: "Please enter Reference Code",
    ChooseSupplier: "Please select Supplier",
    Required: "Please enter this information",
    CannotAccessCam: "Cannot access camera",
    SavingForLogin: "Keep me logged in",
    SavedToClipboard: "Saved value to clipboard.",
    InvalidStore: "Choose a specific store",
    InvalidToken: "User's token is invalid or removed, directing to Login...",
  },
  GlobalPlaceholder: {
    UserName: "Enter user name",
    Email: "Please enter email...",
    Name: "Please enter name...",
    Code: "Please enter code...",
    Partner: "Please select partner",
    Status: "Please select status",
    Phone: "Please enter phone number...",
    Password: "Enter password",
    PasswordConfirmed: "The confirmation password must match the password",
    Description: "Please enter description in text",
    Type: "Please select type",
  },
  GlobalTotalSummary: {
    Success: "Success",
    Error: "Failed",
    Other: "Others",
    Revenue: "Total revenue",
  },
  GlobalService: {
    SIM_ECOMMERCE: "SIM",
    TRAVEL_SIM: "Travel SIM",
    NICE_SIM: "Nice SIM",
    BUY_PACKAGE: "Mobile Plan",
    AIR_TIME: "Top up phone",
    ALL: "All",
  },
  TopupInfo: {
    Title: "Bank Transfer Information",
    AccountName: "Account Name",
    AccountNo: "Account Number",
    Bank: "Bank",
    BankName:
      "Joint Stock Commercial Bank for Investment and Development of Vietnam - North Sai Gon Branch",
    BankAddress:
      "No.290 Nam Ky Khoi Nghia Street, Xuan Hoa Ward, Ho Chi Minh City, Viet Nam",
    BankBranch: "Thu Thiem Branch, Cao Thang Transaction Office",
  },
  Sidebar: {
    General: "Overview",
    Management: "Management",
    History: "Transaction History",
    DataTransaction: "Package",
    SystemConfig: "System Configuration",
    DataPackages: "Data Package",
    RoamingPackages: "Roaming Package",
    UserManagement: "User",
    AffiliateManagement: "Affiliate Management",
    OrderList: "SIM Purchase Order",
    TravelSimList: "Travel SIM Registration",
    Country: "Country",
    PlatformConfig: "Platform",
    Contents: "Article",
    Files: "File",
    CDN: "CDN",
    Address: "Province",
    TopUpForPackage: "Package 4G/5G",
    TopupForSimEcommerce: "Mobifone SIM Package",
    TopUpForTravelService: "Travel SIM Package",
    Suppliers: "Supplier",
  },
  General: {
    Title: "Overview",
    Summary: "Business activity summary",
    ByDate: "By Date",
    ByWeek: "By Week",
    ByMonth: "By Month",
    Revenue: {
      Label: "Revenue",
      CompareWith: "compared to",
      Transaction: "Quantity",
      CurrentDate: "today",
      CurrentMonth: "this month",
      LastMonth: "last month",
      PreviousDate: "yesterday",
      LastMonthDate: "last month",
      LastMonthBefore: "last month before",
      Day: "Today's Revenue",
      Week: "This Week's Revenue",
      Month: "This Month's Revenue",
      WeekOfYear: "Week",
    },
    Charts: {
      Title: "Summary Report",
      Transaction: "Transaction",
      TotalRevenue: "Total Revenue",
      SuccessTransaction: "Total Successful Transactions",
    },
  },
  UserManagement: {
    MainTitle: "System User Management",
    Total: "Total User",
    UserType: {
      Agency: "Agency",
      Store: "Store",
      Employee: "Employee",
    },
    StaffColumns: {
      name: "Name",
      fullName: "Full name",
      code: "Code",
      phone: "Phone number",
      email: "Email",
      address: "Address",
      type: "Position",
      status: "Status",
    },
    Columns: {
      UserName: "Username",
      FullName: "Full Name",
      Email: "Email",
      Partner: "Partner",
      Phone: "Phone Number",
      Balance: "Balance",
      Role: "Role user",
      ResetPass: "Set new password",
      OldPass: "Old password",
      NewPass: "New password",
      UpdateStatus: "Update Status",
    },
    RuleMessage: {
      Url: "Please enter the link as HTTPS URL",
      Name: "Please enter the name",
      Password: "Please enter the password",
      UserName: "Please enter the username",
      IdUrl: "Please enter the marketing link",
      IconUrl: "Please enter the icon link in jpg, png, jpeg format",
      Status: "Please select the status",
      Phone: "Please enter the 10-digit phone number",
      Code: "Please enter the code",
      Role: "Please select the role for the user",
      Partner: "Please select the partner (optional)",
      InvalidPartner: "Invalid partner",
      Balance: "Please enter the limit",
    },
    Labels: {
      Account: "Account",
    },
  },
  PathConfigManagement: {
    Title: "Configuration Management",
    Total: "Total",
    Columns: {
      Title: "Configuration Name",
      Code: "Configuration Code",
      Path: "Path",
      ImageUrl: "Image",
      Description: "Description",
    },
    Placeholder: {
      Title: "Please enter a name",
      Path: "Please enter a path",
      ImageUrl: "Please enter an image URL",
      Description: "Please enter a description",
    },
    Message: {
      AddConfig: "Please declare the JSON configuration below",
    },
  },
  ContentManagement: {
    Title: "Post Management",
    Total: "Total Posts",
    Columns: {
      Name: "Post Name",
      Preview: "Preview",
      Replace: "Replace Posts",
      Download: "Download Posts",
      Delete: "Delete Posts",
      File: "Post File write",
      Image: "Image",
    },
    Message: {
      WrongStructure: "The uploaded file is not in the correct format!",
      NotExisted: "The uploaded file does not exist!",
      Files: "Please enter at least one article file",
      OnlyDocx: "Note: Only enter DOCX files",
      OnlyImages: "Note: Only enter 1 PNG, JPEG, JPG image file",
      MissingAttributes:
        "Please name the article file with the prefix Content for DOC files or Image for image files!",
      AddAttribute:
        "Please name the article file with the prefix Content (Content_abc.docx), the image file with the prefix Image (Image_xyz.png)",
    },
  },
  CountryManagement: {
    Title: "Country Management",
    Total: "Total Countries",
    Columns: {
      Name: "Country Name",
      Code: "Country Code",
      Capital: "Capital",
      Region: "Region",
      Ensign: "Country Flag",
    },
    Regions: {
      Americas: "Americas",
      Europe: "Europe",
      Asia: "Asia",
      Africa: "Africa",
      Oceania: "Oceania",
      Antarctica: "Antarctica",
    },
    Placeholder: {
      Capital: "Please enter the capital name",
      Region: "Please select the country region",
      Cover: "Please enter the image link as URL",
    },
    RoamingPartner: {
      Name: "Partner Name",
      Code: "Partner Code",
    },
    MobileData: {
      Name: "Package Name",
      Code: "Package Code",
      Price: "Package Price",
      Handset: "Handset",
      TransferredData: "Data Group",
      CodeMobileDevice: "Mobile Device Code",
    },
    Message: {
      CoverAttributes: "Please name the cover file with a prefix Cover_",
      EnsignAttributes: "Please select a flag image file!",
    },
  },
  FileManagement: {
    Title: "CDN Management",
    Upload: "Import File",
    Replace: "Replace File",
    Download: "Download File",
    CopyUrl: "Copy URL",
    Placeholder: {
      Type: "Please select file type",
      File: "Please import at least 1 file from your computer",
      Url: "Saved URL to clipboard",
    },
    Columns: {
      Name: "File name",
      Code: "File code",
      Size: "Size",
      Type: "File type",
    },
  },
  RoamingManagement: {
    Title: "Roaming Package Management",
    Total: "Total Roaming Package",
    Add: "Add",
    DetailInfo: "Package Details",
    RoamingPartnerInfo: "Roaming Partner Information",
    Category: {
      Hot: "Hot Package",
      Day: "Day Package",
      Week: "Weekly Package",
      Month: "Monthly Package",
      Roaming: "Roaming Package",
    },
    PlaceHolder: {
      Cover: "Please enter image url...",
      Descriptions: "Please enter description...",
      ShortDes: "Please enter short description...",
      Duration: "Please enter package duration...",
      Price: "Please enter package price...",
      Storage: "Please enter package capacity...",
      DiscountRate: "Please enter discount...",
      InternalCallTotalHour: "Please enter domestic call hours...",
      ExternalCallTotalHour: "Please enter international call hours...",
      Category: "Please select package type...",
      Country: "Please select country...",
    },
    Country: {
      Title: "Country",
      Add: "Add country",
      Edit: "Edit country information",
    },
    RoamingPartner: {
      Title: "Partner",
      Add: "Add Partner",
      Select: "Select Partner",
    },
    Columns: {
      Name: "Package Name",
      Code: "Code",
      Cover: "Image",
      Description: "Description",
      ShortDescription: "ShortDescription",
      Duration: "Package Duration",
      Price: "Price",
      Storage: "Storage",
      DiscountRate: "Discount",
      InternalCallTotalHour: "Internal Call Hours",
      ExternalCallTotalHour: "Outside Call Hours",
      Action: "Action",
      Country: "Country",
      Region: "Region",
      Category: "Package Type",
      Order: "Order",
      Type: "Type",
      SimType: "Sim Type",
      OnlyData: "Data Only",
    },
  },
  TopupManagement: {
    Title: "Data Package Management",
    Total: "Total Package",
    PriceRange: "Price Range",
    Add: "Add Information",
    AddShort: "Add short description",
    AddMore: "Add extended information for the package",
    More: "Extended information for the package",
    MoreInfoName: "Information name",
    MoreInfoItems: "Information",
    ShortDescription: "Short description",
    Order: "By priority",
    OnlyData: "Only Data ?",
    SimType: "Package for SIM ?",
    MoreWithTag: "Package tag",
    TopLeftTitle: "Tag title",
    IsHot: "Is the package HOT ?",
    IsMobileTag: "Does the package have a tag?",
    Generals: "Package information",
    CountryInfo: "Country",
    Columns: {
      Name: "Package name",
      Code: "Package code",
      Order: "Priority",
      DurationDay: "Duration",
      Price: "Package price",
      Storage: "Capacity",
      Category: "Package category",
      InternalCallTotalHour: "Domestic calls",
      ExternalCallTotalHour: "Call outside the network",
    },
    Category: {
      Hot: "Hot package",
      Day: "Day package",
      Week: "Weekly package",
      Month: "Monthly package",
    },
    Placeholder: {
      DurationDay: "Please enter package duration",
      Price: "Please enter the lowest package price of 1,000 VNĐ!",
      Storage: "Please enter the capacity as a number!",
      Cover: "Please enter the link as a URL!",
      Category: "Please select a package type",
      DesAuto:
        "Enter a short description to be able to update the description automatically",
      AutoUpdate: "Update for the whole Description",
      RoamingIsRequired: "Can only access the Country when the Type is Roaming",
      UpdateCountry: "Customize Country information for the Roaming package",
      DuplicatedCode: "This provider's package code already exists",
    },
    SyncFromB2B: {
      Title: "Add data package from B2B",
      Confirm: "Are you sure you want to add packages",
      InvalidPackages: "Please select a package",
    },
    Service: {
      BuyPackage: "Data 4G/5G",
      TravelSim: "Travel SIM",
      SimEcommerce: "Mobifone SIM",
    },
  },
  TransactionHistory: {
    Title: "Package transaction history",
    Total: "Total transactions",
    NoTransRef: "No reference code",
    Customer: "Retail customers",
    Details: "Transaction details",
    StatusCheck: "Check status",
    Message: {
      PartnerListError: "Partner list error",
    },
    Status: {
      Init: "Initialization",
      Progerssing: "Processing",
      Finished: "Completed",
      Error: "Error",
      Deleted: "Deleted",
      WaitingToBeConfirmed: "Waiting for confirmation",
    },
    Placeholder: {
      Code: "Enter transaction code",
      ID: "Enter transaction ID",
      TransRef: "Enter reference code",
    },
    Columns: {
      ID: "Transaction ID",
      Code: "Transaction code",
      TransRef: "Reference code",
      PackageName: "Mobile plan",
      Phone: "Phone number",
      Partner: "Partner",
      Method: "Method",
      TotalAmount: "Total amount",
    },
  },
  AddressManagement: {
    Title: "Province Management",
    DataType: "List data",
    Province: "List of Provinces, Major Cities",
    District: "List of Districts, Counties",
    Wards: "List of Wards, Communes",
    Columns: {
      Name: "Name",
      Code: "Code",
      FullName: "Full name",
      FullNameEn: "Full English name",
      Province: "Province, Major City",
      District: "District, Counties",
      NameEn: "English name",
      Ward: "Ward, Commune",
    },
    Placeholder: {
      Units: "Please select type",
      Regions: "Please select region",
    },
  },
  ChangePassword: {
    Title: "Change password",
    OldPass: "Current password",
    NewPass: "New password",
    Reconfirmed: "Confirm new password",
    Message: {
      InvalidPass: "Please confirm password",
      OldPass: "Please enter old password",
      NewPass: "Please enter new password",
      UnmatchedPass: "Confirmed password does not match",
      ChangePassSucceed: "You have successfully changed your password!",
    },
  },
  SimOrdersForPartners: {
    Title: "List of Sim registration information",
    Columns: {
      CreatedAt: "Creation time",
      OrderCode: "Order code",
      Sim: "Sim number",
      PackageType: "Package type",
      CustomerName: "Customer name",
      CustomerPhone: "Customer phone number",
      Address: "Delivery address",
      Email: "Customer email",
      Partner: "Partner",
    },
    Status: {
      WaitingForPurchased: "Waiting for payment",
      WaitingForDelivered: "Waiting for delivery",
      WaitingForRecieved: "Waiting for receipt",
      Success: "Successfully delivered",
      Canceled: "Cancelled",
      ConnectedSuccessfully: "Connection successful",
      ConnectedFailed: "Connection failed",
    },
    Message: {
      ExcelError: "Error exporting report",
      InvalidSim: "Sim number cannot be blank",
      InvalidPackages: "Enter sim number to display package information",
      InvalidOrderCode: "Order code cannot be blank",
      InvalidPhone:
        "Contact phone number cannot be blank or more than 10 digits!",
      Address: "Please enter customer address",
    },
  },
  TravelSimListManagement: {
    Title: "Travel SIM Registration Information List",
    Placeholder: "Please Enter",
    Detail: "Detailed Information",
    Gender: {
      Male: "Male",
      Female: "Female",
    },
    Labels: {
      Status: "Status",
      Type: "Type",
      Name: "Customer Name",
      ProfileId: "Profile Code",
      Serial: "Serial Number",
      Sim: "Sim Number",
      Detail: "Details",
      Time: "Creation Time",
      IdNumber: "Identification Code",
      Birthday: "Date of Birth",
      Sex: "Gender",
      Address: "Address",
      PlaceOfOrigin: "Hometown",
      IssueDate: "Date of Issue",
      IssuePlace: "Place of Issue",
      PhoneContact: "Phone Number",
      EmailContact: "Email",
      ImagesPath: "Types of Documents",
    },
    ImagePaths: {
      portrait: "Photo portrait",
      front: "Front",
      back: "Back",
      sign: "Signature",
    },
    Status: {
      init: "Initialization",
      isOCR: "OCRed",
      verified: "Verified",
      progress: "Processing",
      success: "Success",
      error: "Failure",
    },
    Type: {
      cccd: "CCCD",
      passport: "Passport",
    },
  },
  RoamingRegistration: {
    Title: "Register for User",
    ModalTitle: "Register for Subscriber",
    Action: "Select Package",
    Phone: "Subscriber to Register",
    Register: "Register",
    AddToList: "Add to Register List",
    AssingedList: "Register List",
    PhoneRegisteredListColumns: {
      Name: "Customer Name",
      Phone: "Registered Subscriber",
      Address: "Address only",
      Price: "Total",
      Email: "Email",
    },
    Columns: {
      Name: "Package name",
      Code: "Package code",
      Type: "Package type",
      Duration: "Duration",
      Capacity: "Capacity",
      Price: "Package price",
      PartnerTransId: "Partner reference code",
    },
    Placehoder: {
      Phone: "Please enter phone number...",
    },
    Message: {
      Success: "Package registration successful",
      Failed: "Package registration for subscriber failed",
      Error: "An error occurred",
      InvalidPackageAndPhone:
        "Please select a package and enter the subscriber to continue!",
      InvalidPackage: "Please select a package!",
      InvalidPhone:
        "Please enter the subscriber number to register for the package!",
      RegisterSuccessfully: "Package registration for subscriber successfully!",
      PhoneRegistrationWarning:
        "This is a reference list, please search with the subscriber number to register to display the list of suitable packages",
      PhoneRegistrationConfirm: "Confirm package registration",
      ForPhone: "for subscribers",
      BasePackagesExisted: "The subscriber to register has a base package",
      RemoveBasePackages:
        "Please cancel the base package before registering a new package!",
      PackagesForSearchedPhone: "List of packages for subscribers",
      NotMobifone:
        "The subscriber does not belong to the Mobifone prefix, please try again!",
      EmptyAssignedList: "The registration list is empty!",
      InvalidPartnerTransId: "Please enter the partner reference code!",
      InvalidPhoneLength: "Please enter a full 10-digit phone number!",
    },
  },
  BalanceHistory: {
    Title: "Balance Adjustment History",
    Approve: "Approve",
    Reject: "Reject",
    Add: "Create Voucher",
    Type: {
      0: "Increase Voucher",
      1: "Decrease Voucher",
    },
    Status: {
      0: "Pending approval",
      1: "Approve",
      2: "Reject",
    },
    ApplicableType: {
      0: "User",
      1: "Partner",
    },
    Placeholder: {
      Type: "Please select voucher type",
      ApplicableType: "Please select applicable object",
      Amount: "Please enter the required amount of at least 1000 VNĐ",
      Phone: "Select applicable object and user or partner to get phone number",
      Partner: "Please select a partner",
      User: "Please select a user",
    },
    Columns: {
      code: "Code",
      phone: "Phone number",
      before: "Balance before approval",
      after: "Balance after approval",
      amount: "Amount requested",
      balance: "Wallet balance",
      applicableType: "Applicable object",
      type: "Type",
      status: "Status",
      createdBy: "Creator",
      updatedBy: "Approver",
      description: "Description",
      createdAt: "Creation date",
      updatedAt: "Update date",
    },
    Message: {
      CreateSuccessfully: "Voucher creation successful!",
      CreateFailed: "Voucher creation failed!",
      ApproveSuccessfully: "Voucher approval successful!",
      ApproveFailed: "Voucher approval failed",
      RejectSuccessfully: "Voucher rejection successful!",
      RejectFailed: "Voucher rejection failed",
    },
  },
  PartnerManagement: {
    Normal: "Normal",
    MainTitle: "Partner Management",
    ipnUrl: "IPN Url",
    Total: "Total Partners",
    CreateUserAfter:
      "After successfully creating a partner, a user profile will be automatically created for that partner",
    UserPartner: "User Profile for the partner",
    CopyUserInfo: "The partner's user profile has been saved to the clipboard",
    Columns: {
      name: "Partner Name",
      code: "Partner Code",
      email: "Email",
      phone: "Phone Number",
      balance: "Balance",
      type: "Type",
      status: "Status",
      affiliateUrl: "Affiliate Link",
      createdAt: "Creation Date",
    },
    Filters: {
      name: "Partner Name",
      code: "Partner Code",
      email: "Email",
      phone: "Phone Number",
      type: "Type",
      status: "Status",
    },
    Detail: {
      id: "ID",
      name: "Partner Name",
      code: "Partner Code",
      email: "Email",
      phone: "Phone Number",
      type: "Type",
      status: "Status",
      publicKey: "Partner Key",
      whnSupplierCode: "WHN Supplier Code",
      token: "Token",
      affiliateUrl: "Affiliate Link",
      icon: "Icon Link",
      address: "Address",
      ipnUrl: "IPN Link",
    },
    Placeholder: {
      SavedPass: "Saved Password",
      SavesName: "Saved Account Name",
    },
    UserInfo: {
      userName: "Account Name",
      password: "Password",
      phone: "Phone Number",
      address: "Address",
      balance: "Balance",
      type: "Type",
      status: "Status",
    },
  },
  RoamingPartner: {
    Active: {
      0: "Roaming",
    },
    Label: "Roaming Partner",
    CountryList: "Country List",
    MobileDataList: "Carrier List",
    Columns: {
      createdAt: "Created Date",
      updatedAt: "Updated Date",
      id: "Partner ID",
      code: "Partner Code",
      name: "Partner Name",
      email: "Email",
      phone: "Phone Number",
      address: "Address",
      type: "Type",
      active: "Activation Status",
      url: "Path",
      order: "Order",
    },
    Filters: {
      name: "Partner Name",
      code: "Partner Code",
      email: "Email",
      phone: "Phone Number",
      type: "Type",
      active: "Activation Status",
    },
    Detail: {
      id: "ID",
      name: "Partner Name",
      code: "Partner Code",
      email: "Email",
      phone: "Phone Number",
      type: "Type",
      active: "Activation Status",
      order: "Order",
      url: "Path",
      address: "Address",
    },
  },
  AppProfileRegister: {
    Title: "Approved Profile History",
    Labels: {
      ApprovedBy: "Approved By",
      DetailProfile: "Profile Details",
      VerifyProfile: "Approved Profile",
      AcceptProfile: "Accept Profile",
      AcceptConfirm: "Do you want to accept this profile?",
      DenyProfile: "Reject Profile",
      DenyConfirm: "Do you want to reject this profile?",
      RejectReason: "Reject Reason",
      SignProfile: "Sign Profile",
      Id: "Profile ID",
      Status: "Status",
      Type: "Contract Type",
      Name: "Profile Name",
      Code: "Profile ID",
      Time: "Created Time",
      UpdatedTime: "Updated Time",
      ProviderCode: "Profile Identifier",
      ProviderPreviewCode: "Provider Profile ID",
      PhoneNumber: "Phone Number",
      ExpriedAt: "Contract Expiry Date",
      ExpriedSignDate: "Signing Expiry Date",
      VerifiedStatus: "Verified Status",
      IsVerified: "Verified",
      NotVerified: "Not Verified",
      File: "Document",
      SyncStatus: "Sync Profile Status",
      SyncAllStatus: "Sync All Profile Status",
      Organization: {
        Name: "Organization",
        Address: "Address",
        Email: "Email",
        TaxCode: "Tax Code",
        Bank: "Bank",
        RepresentativeName: "Representative",
        RepresentativeRole: "Position",
        BusinessCerts: "Business Registration Certificate",
      },
      Participants: {
        Title: "Participants",
        Name: "User name",
        Address: "Address",
        Email: "Email",
        TaxCode: "Tax code",
        Bank: "Bank",
        BankAccount: "Account number",
        Single: "Individual",
        Organization: "Organization",
        Code: "User code",
        RecipentCode: "Supplier user code",
        PhoneNumber: "Phone number",
        Type: "Type",
        Status: "User signed status",
        Images: "Image",
        IDNumber: "CCCD",
        IdIssueDate: "Date of issue",
        IdIssuePlace: "Place of issue",
      },
      AssetsClassify: {
        Avatar: "Profile image",
        BusinessCerts: "Business registration certificate",
        Contract: "Contract",
        IdCard: "CCCD",
        Default: "Image",
      },
      Reason: "Reason",
    },
    Messages: {
      ConfirmAcceptProfile: "Are you sure you want to approve this profile?",
      ConfirmDenyProfile: "Are you sure you want to reject this profile?",
      ConfirmSignProfile: "Are you sure you want to sign the profile?",
    },
    Status: {
      Init: "Initialization",
      Proccessing: "Waiting for signature",
      Approving: "Waiting for approval",
      Approved: "Approved",
      Completed: "Completed",
      Rejected: "Rejected",
      Cancel: "Cancelled",
      Signed: "Signed",
      Expried: "Expired",
    },
    Type: {
      Verified: "Cooperation contract",
    },
  },
  AppTransactionHistory: {
    AppPhoneRechargeTitle: "Phone top-up",
    AppSimMobifoneTitle: "SIM E-commerce",
    AppDataRegisterTitle: "Data Package",
    AppNiceSimTitle: "Nice SIM",
    AppTravelSimTitle: "Travel SIM",
    InboundTravelSimTitle: "Hello Vietnam SIM",
    OutboundTravelSimTitle: "Let's go SIM",
    ExportReportTiTle: "Export transaction history report",
    TransactionHistory: "Transaction History",
    ExportSuccess: "Export report successfully",
    Labels: {
      DetailTrans: "Transaction details",
      Status: "Status",
      Type: "Type",
      Name: "Product name",
      PackageCode: "Package code",
      SimCode: "Sim",
      Code: "Transaction code",
      Time: "Time",
      Service: "Service",
      NumberType: "Number type",
      Product: "Product",
      ProductCode: "Product code",
      IsdnOrIccid: "Phone Number/ICCID",
      ProductPrice: "Product Price",
      PhoneNumber: "Phone Number",
      PaymentMethod: "Method",
      Total: "Total Amount",
      TransRef: "Reference Code",
      Platform: "Platform",
      Description: "Description",
      AmountLabel: {
        product: "Product",
        discount: "Discount",
        userTax: "Tax",
        discountRate: "Discount",
        package: "Package",
        simAdvance: "Sim retention fee",
      },
      NumberTypeOps: {
        MEMORABLE_PHYSICAL: "Noteworthy numbers",
        THREE_7_PHYSICAL: "Triple 7",
        THREE_8_PHYSICAL: "Triple 8",
        THREE_9_PHYSICAL: "Triple 9",
        AB_BA_PHYSICAL: "Pair of numbers AB_BA",
        AB_AB_PHYSICAL: "Pair of numbers AB_AB",
        AA_BB_PHYSICAL: "Pair of numbers AA_BB",
      },
      BuyerName: "Customer",
      BuyerEmail: "Email",
      BuyerPhone: "Phone Number",
      BuyerAddress: "Address",
      UserName: "Executor",
      UserCode: "User Code",
      ProductLabels: {
        SimNumber: "Sim Number",
        SimPrice: "Sim Price",
        SimType: "Sim Type",
        PackageName: "Mobile Plan",
        PackageCode: "Package Code",
        PackagePrice: "Package Price",
        Storage: "Storage quantity",
        Duration: "Duration",
        Serial: "Serial Number",
        Code: "Product Code",
        Price: "Product Price",
      },
    },
    Status: {
      Init: "Initialization",
      Process: "Processing",
      Success: "Success",
      Failed: "Failed",
      Pending: "Waiting for payment",
      PaymentSuccess: "Payment successful",
      Timeout: "Pending",
      Deleted: "Deleted",
    },
    Type: {
      Normal: "Default",
      User: "Individual",
      Partner: "Legal entity",
    },
    TransactionDetail: {
      createdAt: "Created At",
      updatedAt: "Updated At",
      name: "Transaction Name",
      code: "Transaction Code",
      transRef: "Reference Code",
      phoneNumber: "Phone Number",
      serial: "ICCID",
      status: "Status",
      totalPrice: "Total Amount",
      numberType: "Number Type",
      simType: "SIM Type",
      type: "Transaction Type",
      carrier: "Carrier",
      package: "Data Package",
      beforeCredit: "Balance Before Transaction",
      afterCredit: "Balance After Transaction",
      description: "Reason",
      buyerName: "Customer Name",
      buyerEmail: "Customer Email",
      buyerPhone: "Contact Phone Number",
      buyerAddress: "Customer Address",
    },
    ExportReportTransaction: {
      Title: "Export transaction report",
    },
  },
  UserAppManagement: {
    Title: "Manage app users",
    Label: {
      DetailInfo: "Detailed information",
      Address: "Address",
      CreatedTime: "Created time",
      Id: "ID",
      UserName: "Name username",
      FullName: "Full Name",
      Email: "Email",
      Partner: "Partner",
      Phone: "Phone Number",
      Balance: "Balance",
      Role: "Role user",
      Birthday: "Date of Birth",
      Description: "Description",
      TaxCode: "Tax Code",
      LatestContract: "Authentication Profile",
      ResetOTP: "Reset OTP",
    },
  },
  TravelSimProfileRegister: {
    Title: "Travel SIM Registration",
    Status: {
      Init: "Initialization",
      InProgress: "Processing",
      Success: "Success",
      Error: "Error",
      Confirm: "Confirmed",
      Connect: "Connected",
      Approve: "Approved",
    },
    Detail: {
      Buyer: "Order Creator",
      Sim: "SIM Number",
      BuyerEmail: "Contact Email",
      BuyerPhone: "Contact Phone Number",
      BuyerCode: "Buyer Code",
      Serial: "Serial Number",
      Time: "Time",
      Title: "Transaction Details",
      Code: "Code",
      IdNumber: "Passport Number",
      Status: "Status",
      Nationality: "Nationality",
      CodeNumber: "Code",
      PlaceOfOrigin: "Place of Birth",
      IssueDate: "Date of Issue",
      IssuePlace: "Place of Issue",
      Profile: "Profile",
      ExpiryDate: "Expiry Date",
      Note: "Note",
      DialCode: "Country Code",
      Documents: "Documents",
      Front: "Front",
      Back: "Back",
      Portrait: "Portrait",
      Sign: "Signature",
      VideoCall: "Video call",
      FrontDownscale: "Front (zoom out)",
      PortraitDownscale: "Portrait (zoom out)",
      VideoCallDownscale: "Video call (zoom out)",
      Contract: "Contract",
      Policy: "Policy",
    },
    ImagePaths: {
      portrait: "Portrait",
      videocall: "Videocall",
      front: "Front",
      back: "Back",
      sign: "Signature",
      sim: "Sim",
      contractId: "Contract",
      policyId: "Privacy Policy",
      frontDownscaleId: "Front zoom",
      portraitDownscaleId: "Portrait zoom",
      videocallDownscaleId: "Video call zoom",
    },
  },
  PaymentMethod: {
    Label: "Payment Method Management",
    Total: "Total Payment Methods",
    Columns: {
      id: "Method ID",
      name: "Method Name",
      displayName: "Display Name",
      code: "Method Code",
      type: "Type",
      status: "Status",
      order: "Order",
    },
    Filters: {
      name: "Method Name",
      code: "Method Code",
      displayName: "Display Name",
      type: "Type",
      status: "Status",
    },
    Detail: {
      id: "ID",
      name: "Method Name",
      code: "Method Code",
      status: "Status",
      type: "Type",
      displayName: "Display Name",
      supplier: "Supplier",
      cover: "Image",
      description: "Description",
      url: "Path",
      order: "Order",
    },
    Active: {
      1: "Bank",
      2: "E-wallet",
    },
  },
  SupplierManagement: {
    Label: "Supplier Management",
    Total: "Total Suppliers",
    Code: "Supplier Package Code",
    Columns: {
      id: "Supplier ID",
      name: "Supplier Name",
      displayName: "Display Name",
      email: "Email",
      phoneNumber: "Phone Number",
      address: "Address",
      type: "Type",
      status: "Status",
    },
    Filters: {
      name: "Supplier Name",
      displayName: "Display Name",
      email: "Email",
      phoneNumber: "Phone Number",
      type: "Type",
      status: "Status",
    },
    Detail: {
      id: "ID",
      name: "Supplier Name",
      status: "Status",
      type: "Type",
      displayName: "Display Name",
      email: "Email",
      phoneNumber: "Phone Number",
      address: "Address",
      cover: "Image",
      image: "Image",
      description: "Description",
      order: "Order",
    },
    Active: {
      0: "Default",
      1: "Payment",
      2: "OCR",
    },
  },
  AirTimeManagement: {
    Label: "Manage phone top-up denominations",
    Total: "Total phone top-up denominations",
    Columns: {
      id: "Denomination ID",
      name: "Denomination Name",
      code: "Denomination Code",
      amount: "Amount",
      type: "Type",
      status: "Status",
    },
    Filters: {
      name: "Denomination Name",
      code: "Denomination Code",
      amount: "Amount",
      status: "Status",
    },
    Detail: {
      name: "Denomination Name",
      code: "Denomination code",
      amount: "Amount",
      status: "Status",
      type: "Type",
      carrier: "Carrier",
      config: "Configuration",
      description: "Description",
    },
    Supplier: {
      name: "Supplier Name",
      displayName: "Display Name",
      address: "Address",
      email: "Email",
      phoneNumber: "Phone Number",
      description: "Description",
    },
    Type: {
      0: "Phone Card",
    },
  },
  DiscountManagement: {
    Title: "Discount Management",
    CreateDiscount: "Create Discount",
    UpdateDiscount: "Update Discount",
    Columns: {
      id: "ID",
      createdAt: "Created Date",
      updatedAt: "Updated Date",
      name: "Discount Name",
      code: "Discount Code",
      type: "Discount Type",
      order: "Order",
      note: "Note",
      discountRate: "Discount",
      parentId: "Belongs to discount group",
      service: "Service",
      group: "Product group",
      product: "Product",
      parent: "Parent discount",
      parentCode: "Parent discount code",
      parentRate: "Parent discount rate",
      AddNewUser: "Add user",
    },
    Filters: {
      status: "Status",
      type: "Type",
      user: "User",
      service: "Service",
      group: "Product group",
    },
    Messages: {
      Required: "Please fill in this information",
    },
  },
  SimManagement: {
    Title: "Sim Management",
    DownloadTemplate: "Download sim import form",
    UploadFile: "Upload sim import form",
    ImportSim: "Import sim",
    ImportTable: "Import sim directly",
    ImportFile: "Import sim from file",
    ImportSuccess: "Import sim successfully",
    AddRow: "Add row",
    QuickUpdate: "Do you want to update quickly?",
    ErrorMessage1: "The form you just imported is available",
    ErrorMessage2: "Error row",
    SimDetail: "Sim information",
    Status: {
      Active: "Available",
      Inactive: "Unavailable",
      Sold: "Sold",
      Deleted: "Deleted",
    },
    SimType: {
      Physical: "Physical SIM",
      ESim: "eSIM",
    },
    Fields: {
      Code: "Identifier",
      Name: "Display name",
      Serial: "Serial",
      PhoneNumber: "Sim Number",
      Status: "Status",
      Type: "Service",
      SimType: "Sim Type",
      SKU: "SKU Code",
      Zodiac: "Zodiac Sign",
      Numerology: "Numerology",
      Destiny: "Destiny",
      Description: "Description",
      ShortDescription: "Short Description",
    },
  },
  SupportFeature: {
    MainTitle: "Support",
    PackageLookup: {
      Title: "Mobile Plan Lookup",
      Input: {
        Placeholder: "Enter subscriber number/ICCID",
      },
      Output: {
        Capacity: "Capacity",
        UsedCapacity: "Used Capacity",
        RemaingCapacity: "Remaining Capacity",
        Package: "Package Name",
        PackageCapacity: "Package Capacity",
      },
    },
    SimLookup: {
      Title: "SIM Lookup",
      Input: {
        Placeholder: "Enter subscriber number/ICCID",
        QRCode: "SIM QRCode",
      },
      Output: {
        isActivated: "SIM has been activated",
        isUnactivated: "SIM has not been activated",
      },
      Message: {
        NumberOrQr:
          "Please enter the phone number/ICCID or upload the SIM QR code image.",
      },
    },
    ApiDoc: {
      Title: "API Documentation",
    },
    Dispatch: {
      Title: "Official Dispatch",
    },
  },
  CashFlow: {
    MainTitle: "Cash Flow",
    Columns: {
      TransCode: "Transaction Code",
      CostIn: "Cash Inflow",
      CostOut: "Cash Outflow",
      Wallet: "Closing Balance",
      Content: "Transfer Details",
    },
    Filters: {
      Type: "Content",
      Code: "Transaction code",
      Debit: "Disbursement",
      Withdraw: "Cash Outflow",
      Deposit: "Deposit",
      Refund: "Refund",
    },
  },
  StaffManagement: {
    Title: "Account Management",
    MainTitle: "User Management",
  },
};
